import { render, staticRenderFns } from "./spike-session.vue?vue&type=template&id=2a84931d&scoped=true&"
import script from "./spike-session.vue?vue&type=script&lang=js&"
export * from "./spike-session.vue?vue&type=script&lang=js&"
import style0 from "./spike-session.vue?vue&type=style&index=0&id=2a84931d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a84931d",
  null
  
)

export default component.exports